var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm"}):_c('div',[_c('NbSelectInput',{attrs:{"options":_vm.options,"id":"select-action","error":_vm.errors},model:{value:(_vm.actionValue),callback:function ($$v) {_vm.actionValue=$$v},expression:"actionValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }